module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_08@2x-20c79361327590223e87b914ff414794.jpg";